/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Change_Type_HeaderInputs */



/**
* | output |
* | --- |
* | "Change Type" |
*
* @param {Compare_Event_Groups_Csv_Change_Type_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_change_type_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Change_Type_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Change_Type_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type de modification")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungstyp")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cambia tipo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменить тип")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar tipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更改类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイプの変更")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिवर्तन का प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterar tipo")
	return /** @type {LocalizedString} */ ("Change Type")
});